import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEChildrenIncomeRowActions = {
  initPeChildrenIncomeRow: ({ commit }, index) => {
    commit('setPeChildrenIncomeRowLock', { index, lock: true })
  },
  peChildrenIncomeRefreshAll: ({ state, dispatch, commit }) => {
    for (const child of state.partyEdit.party.children) {
      dispatch('peChildrenCardRefresh', { section: child, index: child.id })
      commit('setPeChildrenIncomeRowLock', { index: child.id, lock: true })
    }
  },
  peChildrenIncomeRowUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        children: {
          party_id: party.id,
          monthly_income: section.monthly_income,
          income_verification: section.income_verification,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeChildrenIncomeRowLock', { index, lock: true })
        commit('pePatchParty', {
          children: updatedParty.children || [],
        })
      }).
      catch(handleError)
  },
}

export const PEChildrenIncomeRowMutations = {
  setPeChildrenIncomeRowLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.ChildrenIncomeRow) {
      Vue.set(state.partyEdit.partySections, 'ChildrenIncomeRow', {})
    }
    Vue.set(state.partyEdit.partySections.ChildrenIncomeRow, index, lock)
  },
}

export const PEChildrenIncomeRowGetters = {
  peChildrenIncomeRowLock: state => index => state.partyEdit.partySections.ChildrenIncomeRow[index],
}
